import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { APPLICATIONS, IMAGES } from "../data/site";

export const Applications = () => (
  <section id="applications" data-testid="applications-section" className="bg-white py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        kicker="Applications"
        title="Built for Every Space"
        desc="From single homes to large commercial and institutional projects — one frame system, everywhere."
      />
      <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {APPLICATIONS.map((a, i) => (
          <Reveal key={a.title} delay={(i % 4) * 0.07}>
            <div
              data-testid={`application-card-${i}`}
              className="group relative h-52 sm:h-64 overflow-hidden border border-black/10"
            >
              <img
                src={IMAGES[a.img]}
                alt={`Steel door frames for ${a.title.toLowerCase()}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-coal/95 via-brand-coal/25 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-4 sm:p-5 flex items-end justify-between gap-3">
                <span className="font-display text-base sm:text-lg font-semibold uppercase tracking-wide text-white leading-tight">
                  {a.title}
                </span>
                <span className="font-display text-sm text-brand-red font-semibold shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <span className="absolute top-0 left-0 h-[3px] w-0 bg-brand-red group-hover:w-full transition-[width] duration-500" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
